import { z } from 'zod';

export const AwardModelSchema = z.object({
    uid: z.string(),
    description: z.any().optional().nullable(),
    image: z.object({
        url: z.string(),
    }).optional().nullable(),
    years: z.array(z.string()),
});

export type AwardModel = z.infer<typeof AwardModelSchema>;
